import { QRCodeCanvas } from 'qrcode.react';
import { Stack, Typography, IconButton } from '@mui/material';
import QRCodeIcon from '@mui/icons-material/QrCode2Rounded';

import { downloadQR } from 'redux/slices/qr/qrCodeSlice';
import { GenerateQRProps } from 'types/common';
import CustomButton from 'components/Common/Button';
import InfoModal from 'components/Common/InfoModal';
import { useState } from 'react';
import Colors from 'constants/colors';
import { APP_PROTOCOL, QR_BASE_URL } from 'config/apiConfig';

const GenerateQRCode: React.FC<GenerateQRProps> = ({ basket }) => {
    const { id } = basket || {};
    const [showQR, setShowQR] = useState<boolean>(false);

    const handleDownloadQR = () => {
        try {
            if (id) {
                downloadQR('generate-qr-code', String(id));
            }
        } catch (e) {
            console.log('$$$ ~ handleDownloadQR ~ e:', e);
        }
    };

    return (
        <>
            <IconButton onClick={() => setShowQR(true)}>
                <QRCodeIcon htmlColor={Colors.darkblue} sx={{ width: 50, height: 50 }} />
            </IconButton>
            <InfoModal title="" isOpen={showQR} onClose={() => setShowQR(false)} hideActionButtons>
                <>
                    <Stack alignItems="center" mb={5}>
                        <Typography className="two-line-text" fontSize="35px" mb={3}>
                            {basket?.name}
                        </Typography>
                        <QRCodeCanvas
                            id="generate-qr-code"
                            value={`${QR_BASE_URL}/?app_protocol=${APP_PROTOCOL}://sendPayment&merchantId=${id}&amount=0.0`}
                            size={300}
                        />
                    </Stack>
                    <Stack width="100%" alignItems="center">
                        <CustomButton width={200} onClick={handleDownloadQR}>
                            Download
                        </CustomButton>
                    </Stack>
                </>
            </InfoModal>
        </>
    );
};

export default GenerateQRCode;
